export default __webpack_public_path__ + "static/media/GoodMannersWithYourTeachers_08.9403388b.png";